import { useEffect } from 'react';

type Props = {
  email: string;
};
const ProfitWell = ({ email }: Props) => {
  useEffect(() => {
    if (email && window.profitwell) {
      window.profitwell('start', { user_email: email });
    }
  }, [email]);

  return null;
};

export default ProfitWell;
